import React, { FormEvent, useEffect, useState } from "react"

import { useAuth } from "../../hooks/useAuth";

import axios from "axios";

import { FaSearch } from "react-icons/fa";

import {
    Container,
    Main,
    Table,
    TableBody,
    TableHeader,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableHeadRow,
    FilterButton,
    FilterContainer,
    FilterInput,
    FilterInputContainer,
    FormContainer,
    Loading
} from './styles';

import Pagination from "../../components/Pagination";
import { IsseusPage } from "../../interfaces";

interface IIssueProps {
    id: string;
    dev: string;
    summary: string;
    started: string;
    status: string,
    timeSpentSeconds: number;
    sprintArr: {
        id: string;
        name: string;
        endDate: string;
    }[];
}

function parseData(data: any, timezone: string) {
    const date = new Date(String(data));
    const timeFormat: Intl.DateTimeFormatOptions = { month: '2-digit', day: '2-digit', year: '2-digit', timeZone: timezone};
    let result: string = date.toLocaleString('pt-BR', timeFormat);
    return result;
}

const Project: React.FC = () => {

    const { user } = useAuth();

    const [loading, setLoading] = useState(true);
    const [access, setAccess] = useState<boolean>(!user.clientJiraCodMain);

    const [searchText, setSearchText] = useState('');

    const [pageNumber, setPageNumber] = useState<number>(0);
    const [pagePagination, setPagePagination] = useState<IsseusPage>({
        first: true,
        last: true,
        number: 0,
        totalPages: 0
    });
    const [pageData, setPageData] = useState<IIssueProps[]>([]);


    useEffect(() => {

        loadIssues(searchText);
        setLoading(false);

    }, [pageNumber]);

    async function loadIssues(pesquisa: string) {

        await axios.get(`https://hook.us1.make.com/mgn3ypdyqciy2fng9ebx2r36hvpmrfm5`, {
            params: {
                operacao: 'projeto',
                pesquisa: pesquisa,
                issue: user.clientJiraCodMain,
                inicio: (pageNumber * 20)
            }
        }).then(response => {
            const r = response.data?.issues.map((item: any): IIssueProps => {
                return {
                    id: item.id,
                    dev: item?.fields?.assignee?.displayName,
                    summary: item?.fields?.summary,
                    started: '',
                    status: item?.fields?.status?.name,
                    timeSpentSeconds: item?.fields?.progress?.total,
                    sprintArr: item?.fields?.customfield_10020,
                }
            })
            const maxResults = response.data?.maxResults;
            const startAt = response.data?.startAt;
            const total = response.data?.total;

            let last: boolean;
            let totalPages: number;
            let first: boolean;

            if (Number(startAt) == 0) {
                first = true;
            } else {
                first = false;
            }

            if ((Number(startAt) + 20) > total) {
                last = true;
            } else {
                last = false;
            }
            totalPages = Math.ceil(total / maxResults)

            setPagePagination({
                first: first,
                last: last,
                number: pageNumber,
                totalPages: totalPages
            })

            setPageData(r);

        }).catch(error => {
            console.log(error)
        })

    }

    const handlePageChange = (newPageNumber: number) => {
        setPageNumber(newPageNumber);
    }

    function handleFilter(event: FormEvent) {
        event.preventDefault();

        loadIssues(searchText);
        setPageNumber(0);

    }

    if (loading) {
        return (
            <Loading>
                <div></div>
            </Loading>
        )
    }

    if (access) {
        return (
            <div>
                <h3>Funcionalidade ainda em desenvolvimento, em breve você terá acesso a essa área.</h3>
            </div>
        )
    }

    return (
        <Container>
            <Main>
                <h1>Projeto</h1>

                <FilterContainer>
                    <FormContainer onSubmit={handleFilter}>
                        <FilterContainer>
                            <FilterInputContainer>
                                <FaSearch />
                                <FilterInput
                                    placeholder="Pesquise..."
                                    onChange={e => setSearchText(e.target.value)}
                                />
                            </FilterInputContainer>
                        </FilterContainer>
                        <FilterButton type="submit">
                            Buscar
                        </FilterButton>
                    </FormContainer>
                </FilterContainer>

                <TableContainer>
                    <Table>
                        <TableHeader>
                            <TableHeadRow>
                                {/* <TableHead></TableHead> */}
                                <TableHead>Desenvolvedor</TableHead>
                                <TableHead>Tempo</TableHead>
                                <TableHead>Resumo</TableHead>
                                <TableHead>Status</TableHead>
                                <TableHead>Conclusão/Previsão</TableHead>
                            </TableHeadRow>
                        </TableHeader>

                        <TableBody>
                            {pageData.map(item => {
                                let mensagemTempo;
                                if (item?.timeSpentSeconds == 0) {
                                    mensagemTempo = '0';
                                } else {
                                    const totalMinutos = (item?.timeSpentSeconds / 60);
                                    const minMensagem = (totalMinutos % 60);

                                    const horasMensagem = Math.floor(totalMinutos / 60);

                                    mensagemTempo = `${horasMensagem}h ${minMensagem}min`
                                }

                                let nomeDev;
                                if (item?.dev == '') {
                                    nomeDev = 'Não selecionado'
                                } else {
                                    nomeDev = item?.dev;
                                }

                                let nomeStatus;
                                switch (item?.status) {
                                    case 'To Do':
                                        nomeStatus = 'Pendente'
                                        break;

                                    case 'Done':
                                        nomeStatus = 'Finalizado'
                                        break;

                                    case 'In Progress':
                                        nomeStatus = 'Em desenvolvimento'
                                        break;

                                    default:
                                        nomeStatus = ''
                                        break;
                                }


                                let dataConclusao = '';
                                if (item.sprintArr != null && item.sprintArr.length > 0) {
                                    item.sprintArr.sort((a, b) => Number(b.id) - Number(a.id));
                                    dataConclusao = parseData(item.sprintArr[0].endDate, 'America/Sao_Paulo');;
                                }

                                return (
                                    <TableRow key={item?.id}>
                                        {/* <TableCell></TableCell> */}
                                        <TableCell>{nomeDev}</TableCell>
                                        <TableCell>{mensagemTempo}</TableCell>
                                        <TableCell>{item?.summary}</TableCell>
                                        <TableCell>{nomeStatus}</TableCell>
                                        <TableCell>{dataConclusao}</TableCell>
                                    </TableRow>

                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Pagination onChange={handlePageChange} page={pagePagination} />
            </Main>

        </Container>
    )
}

export default Project;
